import React, { useEffect, useState } from 'react';
import BusinessCardHeader from './BusinessCardHeader/BusinessCardHeader';
import Profile from '../../assets/images/profile.jpg';
import phone from '../../assets/images/phone.svg';
import envelopContact from '../../assets/images/envelopeContact.svg';
import external from '../../assets/images/external-link-square.svg';
import './style.scss';
import config from '../../Config.js';
import Button from '../../components/Shared/components/controls/Button';
import Loader from '../IBANGeneratorComponent/Loader/index';
const BusinessCard = (props) => {
  const [cardData, setCardData] = useState(null);
  const [photosrc, setPhotosrc] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBusinessCard = async () => {
      try {
        setLoading(true);
        // Retrieve UserId from the URL's query parameters
        const urlParams = new URLSearchParams(window.location.search);
        const Ref = urlParams.get('ref');

        // Ensure userId is present
        if (!Ref) {
          throw new Error('UserId parameter is missing in the URL');
        }

        const url = `${config.hostname}/api/businesscard/GetBusinessCardInfo?ref=${Ref}`;
        const response = await fetch(url);
        console.log('Response:', response); // Log the response object
        if (!response.ok ) {
         // throw new Error('Network response was not ok');
         window.location.href = '/';
          return;
        }

        const data = await response.json();
        if(data?.StatusCode !== 200) {
          window.location.href = '/';
          return; 
        }
        console.log('Business Card Data:', data); // Log the fetched data
        // Check if image exists and set it, otherwise set empty string
        const imageBase64 = data?.Data?.Image;
        setPhotosrc(imageBase64 ? `data:image/png;base64,${imageBase64}` : '');

        setCardData(data);
      } catch (error) {
        console.error('Error fetching business card data:', error);
        window.location.href = '/';
      }
      finally {
        setLoading(false);
      }
    };

    fetchBusinessCard();
  }, []);
  function saveContact() {
   // Get the contact information from the website
   var contact = {
      name: cardData?.Data.FirstName,
      phone: cardData?.Data.Phone,
      email: cardData?.Data.Email,
      photo: cardData?.Data.Image, // Assuming this is already base64 encoded,
      website: cardData?.Data.Website,
      title: cardData?.Data.JobTiltle,
    };
    

const vcard = 
  "BEGIN:VCARD\n" +
  "VERSION:3.0\n" +
  `N:${contact.name.split(' ').reverse().join(';')};\n` +
  `FN:${contact.name}\n` +
  `TITLE:${contact.title}\n` +
  `TEL;TYPE=CELL:${contact.phone}\n`;

// Add optional fields if they exist
const vcardWithOptionalFields = 
  (contact.email ? `${vcard}EMAIL;TYPE=INTERNET:${contact.email}\n` : vcard) +
  (contact.website ? `URL:${contact.website}\n` : "") ;

// Add photo if photosrc exists (using the external photosrc variable)
const finalVcard = contact.photo ? 
  `${vcardWithOptionalFields}PHOTO;ENCODING=b;TYPE=JPEG:${contact.photo}\nEND:VCARD` : 
  `${vcardWithOptionalFields}END:VCARD`;

var blob = new Blob([finalVcard], { type: "text/vcard" });
var url = URL.createObjectURL(blob);

const newLink = document.createElement('a');
newLink.download = contact.name + ".vcf";
newLink.textContent = contact.name;
newLink.href = url;

newLink.click();
    }
    if (loading) {
      return (
        <div className="loader-container">
          <Loader />
        </div>
      );
    }
  return (
    <div className="cardContainer">
      <BusinessCardHeader />
      {/* profile picture */}
      <div className="pictureContainer">
             <img src={photosrc || Profile} alt="profile picture" />
        </div>
      <div className="infoContainer">
        <div className="name">{cardData?.Data.FirstName} {cardData?.Data.LastName}</div>
        <div className="jobTitle">{cardData?.Data.JobTiltle}</div>
        <div className="company">First Abu Dhabi Bank Misr.</div>
      </div>
      {/* personal info */}
      <div className="personalContainer">
        <div className="infoRow">
          <img src={phone} />
          <span>{cardData?.Data.Phone}</span>
        </div>
        <div className="infoRow">
          <img src={envelopContact} />
          <span>{cardData?.Data.Email}</span>
        </div>
        <div className="infoRow">
          <img src={external} />
          <span>{cardData?.Data.Website}</span>
        </div>
      </div>
      {/* button */}
      <div className="btnContainer">
        <Button className="submitBtn" onClick={saveContact}>Save Contact</Button>
      </div>
    </div>
  );
};
export default BusinessCard;

